
/*
form is where we have all the details for all the inputs
for the entity  forms
each entity has their own form
*/

const {states} = require ('../../../../../js-handler/library/states') 

export const form   =  [
	{	
		name: "code", 
		value:'', 		
		id:'saleDeleted_form_code',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "customer_id", 
		value:[], 	//just the id	
		valueFull:'',
		id:'saleDeleted_form_customer_id',
		html:'',
		type:'autocomplete',
		required: true,  
	},
	{	
		name: "sale_date", 
		value:'0000-00-00',
		date: true, 		
		id:'saleDeleted_form_sale_date',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "due_date", 
		value:'0000-00-00',
		date: true, 		
		id:'saleDeleted_form_due_date',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "printed_note", 
		value:'',
		id:'saleDeleted_printed_note',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "email", 
		value:'',
		id:'saleDeleted_form_email',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "bill_to_address", 
		value:'', 		
		id:'saleDeleted_form_bill_to_address',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "bill_to_apt", 
		value:'', 		
		id:'saleDeleted_form_bill_to_apt',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "bill_to_city", 
		value:'', 		
		id:'saleDeleted_form_bill_to_city',
		html:'',
		type:'textfield',
		required: false,  
	},
	{  name: "bill_to_state", 
	   value:'', 		
	   id:'saleDeleted_form_bill_to_state',
	   html:'',
	   type:'multiselect',
	   options : states, 
	   required: false, 
	},
	{	
		name: "bill_to_zip", 
		value:'', 		
		id:'saleDeleted_form_bill_to_zip',
		html:'',
		type:'textfield',
		required: false,  
	},	{	
		name: "ship_to_address", 
		value:'', 		
		id:'saleDeleted_form_ship_to_address',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "ship_to_apt", 
		value:'', 		
		id:'saleDeleted_form_ship_to_apt',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "ship_to_city", 
		value:'', 		
		id:'saleDeleted_form_ship_to_city',
		html:'',
		type:'textfield',
		required: false,  
	},
	{  name: "ship_to_state", 
	   value:'', 		
	   id:'saleDeleted_form_ship_to_state',
	   html:'',
	   type:'multiselect',
	   options : states, 
	   required: false, 
	},
	{	
		name: "ship_to_zip", 
		value:'', 		
		id:'saleDeleted_form_ship_to_zip',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "grand_total", 
		value:'', 		
		id:'saleDeleted_form_grand_total',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "ship_via", 
		value:'', 		
		id:'saleDeleted_form_ship_via',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "shipping_date", 
		value:'0000-00-00',
		date: true, 		
		id:'saleDeleted_form_shipping_date',
		html:'',
		type:'textfield',
		required: false,  
	},
	{ name: "shipping_time", 
		value:'00:00', time: true, 			
		id:'saleDeleted_form_shipping_time',
		html:'',
		type:'textfield',
		required: false,  
	}, 
	{	
		name: "shipping_status", 
		value:'', 		
		id:'saleDeleted_form_shipping_status',
		html:'',
		type:'multiselect',
		options :[{value:'preparing', text:'Preparing'}, {value:'shipped', text:'Shipped'},
				  {value:'delivered', text:'Delivered'}, {value:'ready to pickup', text:'Ready To Pickup'}], 
		required: false, 
	},
	{	
		name: "terms", 
		value:'', 		
		id:'saleDeleted_form_terms',
		html:'',
		type:'multiselect',
		options :[{value:'15', text:'15 days'}, {value:'21', text:'21 days'},
				  {value:'30', text:'30 days'}], 
		required: false, 
	},
	{	
		name: "delivered_date", 
		value:'0000-00-00',
		date: true, 		
		id:'saleDeleted_form_delivered_date',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "tracking_number", 
		value:'', 		
		id:'saleDeleted_form_tracking_number',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "notes", 
		value:'', 
		id:'saleDeleted_form_notes',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "packslip_notes", 
		value:'', 
		id:'saleDeleted_form_packslip_notes',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "sale_statement", 
		value:'', 
		id:'saleDeleted_form_sale_statement',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "sale_footer", 
		value:'', 
		id:'saleDeleted_form_sale_footer',
		html:'',
		type:'textfield',
		required: false,  
	},
]



//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form)) 



